import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { WorkingConditionVersionApplicationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'

import MissingData from './MissingData'
import Promotion from './Promotion'
import WorkingConditions from './WorkingConditions'

interface Props {
  contractVersion: ContractVersion
  employee: Employee
  workingConditionVersionApplication?: WorkingConditionVersionApplicationFragment
}

const Tags = ({ contractVersion, employee, workingConditionVersionApplication }: Props) => {
  return (
    <>
      <Box gap="s8" flexDirection="row" alignItems="center">
        <MissingData contractVersion={contractVersion} employee={employee} />
        <Promotion authorName={contractVersion.authorName} />
      </Box>
      {workingConditionVersionApplication && (
        <WorkingConditions
          workingConditionVersionApplication={workingConditionVersionApplication}
        />
      )}
    </>
  )
}

export default observer(Tags)
